var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    focusable: "false",
    color: "var(--token-7bc77d28-260e-4b84-92a3-3084b520b0ce, rgb(255, 255, 255))",
    style: {
      userSelect: "none",
      width: "100%",
      height: "100%",
      display: "inline-block",
      fill: "var(--token-7bc77d28-260e-4b84-92a3-3084b520b0ce, rgb(255, 255, 255))",
      color: "var(--token-7bc77d28-260e-4b84-92a3-3084b520b0ce, rgb(255, 255, 255))",
      flexShrink: 0
    },
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    color: "var(--token-7bc77d28-260e-4b84-92a3-3084b520b0ce, rgb(255, 255, 255))",
    weight: "regular",
    fill: "#FFFCF5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232,48H160a40,40,0,0,0-32,16A40,40,0,0,0,96,48H24a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8H96a24,24,0,0,1,24,24,8,8,0,0,0,16,0,24,24,0,0,1,24-24h72a8,8,0,0,0,8-8V56A8,8,0,0,0,232,48ZM96,192H32V64H96a24,24,0,0,1,24,24V200A39.81,39.81,0,0,0,96,192Zm128,0H160a39.81,39.81,0,0,0-24,8V88a24,24,0,0,1,24-24h64Z",
    fill: "#FFFCF5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEd);
export default __webpack_public_path__ + "static/media/ed.d7e2b2d62c8e34bf934f9baf989f6b52.svg";
export { ForwardRef as ReactComponent };